import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { IconButton } from '@atlaskit/button/new';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { Inline, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
import React, { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = xcss({
  marginRight: 'space.025',
  textAlign: 'center',
  width: 'size.400',
  height: 'size.200'
});
const ClearSearchIcon = () => /*#__PURE__*/_jsx(CrossCircleIcon, {
  size: "small",
  primaryColor: "var(--ds-icon, #44546F)"
  // Empty label here as the label is handled by the parent IconButton component
  ,
  label: ""
});
/**
 * Replaces the default Dropdown Indicator component in React Select.
 * When there is a search input value, it shows a Clear icon, which clears the search input text when clicked.
 * Otherwise, it displays a search icon.
 *
 *  Separate `Internal` component created for the custom UI, to make it easier to test.
 * `CustomDropdownIndicator` is passed to react select, and requires additional props that are
 * internally used by react select, so is difficult to test.
 */
export const CustomDropdownIndicatorInternal = _ref => {
  let {
    searchInputValue,
    testIdPrefix,
    onClearSearchButtonClick
  } = _ref;
  const handleClick = useCallback(event => {
    event.preventDefault();
    onClearSearchButtonClick();
  }, [onClearSearchButtonClick]);
  return /*#__PURE__*/_jsx(Inline, {
    xcss: wrapperStyles,
    alignBlock: "center",
    alignInline: "center",
    children: searchInputValue ? /*#__PURE__*/_jsx(IconButton, {
      label: "Clear search text",
      icon: ClearSearchIcon,
      shape: "circle",
      appearance: "subtle",
      spacing: "compact",
      testId: "".concat(testIdPrefix, ".clear-search-text-button"),
      onClick: handleClick
    }) : /*#__PURE__*/_jsx(SearchIcon, {
      size: "small",
      label: ""
    })
  });
};
export const CustomDropdownIndicator = props => {
  const {
    inputValue,
    onInputChange
  } = props.selectProps;
  const handleClick = useCallback(() => {
    onInputChange('', {
      action: 'input-change',
      prevInputValue: inputValue
    });
  }, [inputValue, onInputChange]);
  return /*#__PURE__*/_jsx(components.DropdownIndicator, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(CustomDropdownIndicatorInternal, {
      searchInputValue: props.selectProps.inputValue,
      testIdPrefix: props.selectProps.testId,
      onClearSearchButtonClick: handleClick
    })
  }));
};